import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Sumalatha from '../../assets/Rehab staff/Sumalatha.JPG';
import Harish from '../../assets/Rehab staff/Haresh kumar.JPG';
import Hemalatha from '../../assets/Rehab staff/Hemalatha.JPG';

const teamMembers = [
  {
    name: "P. Hemalatha",
    role: "Principal",
    bio: "Experienced educator dedicated to special needs education.",
    image: Hemalatha,
  },
  {
    name: "M. Harish",
    role: "Special Educator",
    bio: "Committed to supporting students with diverse learning needs.",
    image: Harish,
  },
  {
    name: "S. Sumalatha",
    role: "Special Educator",
    bio: "Dedicated to empowering students through tailored education.",
    image: Sumalatha,
  },
  
];

const sections = [
  {
    title: 'Our Services',
    items: [
      { heading: 'Vocational Training', content: 'Our vocational training program provides individuals with the skills and training they need to secure employment and self-employment in various sectors, including agriculture, hospitality, and industrial sectors.' },
      { heading: 'Life Skills Training', content: 'This program helps individuals develop essential skills for daily living, such as cooking, cleaning, budgeting, and other activities required for independent living.' },
      { heading: 'Social Skills Training', content: 'Our social skills training helps individuals develop communication, relationship-building, and conflict-resolution skills to improve their social interactions.' },
      { heading: 'Recreational Activities', content: 'Our recreational activities program provides individuals with opportunities to engage in leisure activities such as sports, arts, and crafts, promoting overall well-being and socialization.' },
      { heading: 'Support Services', content: 'We provide various support services, including counseling, case management, and advocacy, to assist individuals in navigating their rehabilitation journey.' }
    ]
  },
  {
    title: 'Residential Services',
    items: [
      { heading: 'Group Homes', content: 'These homes provide a supportive and structured living environment, offering shared spaces and on-site support staff for individuals requiring assistance in daily living.' },
      { heading: 'Independent Living', content: 'Our independent living program helps individuals live on their own with minimal support, including assistance with daily tasks and access to community resources.' },
      { heading: 'Residential Support Services', content: 'We offer ongoing support to individuals living in residential settings, ensuring they receive the necessary care and assistance to thrive in their environment.' }
    ]
  },
  {
    title: 'Specialized Programs',
    items: [
      { heading: 'Autism Spectrum Disorder (ASD) Program', content: 'We offer specialized services for individuals with autism, including vocational training, life skills development, and social skills training to help individuals reach their full potential.' },
      { heading: 'Intellectual Disability Program', content: 'This program provides specialized services for individuals with intellectual disabilities, including vocational training, life skills training, and social support.' },
      { heading: 'Transition Program', content: 'Our transition program assists individuals in the move from school to adulthood, focusing on career readiness, independent living, and social skills.' }
    ]
  }
];

const OcationalRehabilitation = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div>

      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Vocational Rehabilitation & Adult Living</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Vocational Rehabilitation and Adult Living for Neurodevelopmental Disorders at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            We are dedicated to empowering individuals with neurodevelopmental disorders by providing specialized vocational rehabilitation and adult living services. Our goal is to help individuals achieve independence, gain valuable skills, and integrate into the community successfully.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.heading}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to providing high-quality, person-centered care. Our team of professionals works diligently to ensure individuals with neurodevelopmental disorders receive the support and services they need to live fulfilling and independent lives.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To learn more about our <strong>Vocational Rehabilitation and Adult Living services</strong>, or to schedule an appointment, click below and fill out our appointment request form.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />
    </div>
  );
};

export default OcationalRehabilitation;
